import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function ChevronUp({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M18.4142 14.7071L17 16.1213L11.7071 10.8284L6.41418 16.1213L4.99997 14.7071L11.7071 7.99999L18.4142 14.7071Z"
        fill={iconColor}
      />
    </Svg>
  );
}
